module.exports = __webpack_public_path__ + "787e0d59a24dfb0a75f94b2cc03108da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navbar_0.png
// module id = 225
// module chunks = 30